var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3297 4.78995L2.0897 0.549949C1.99674 0.45622 1.88613 0.381826 1.76428 0.331057C1.64242 0.280288 1.51171 0.25415 1.3797 0.25415C1.24769 0.25415 1.11698 0.280288 0.995122 0.331057C0.873263 0.381826 0.762662 0.45622 0.669699 0.549949C0.483448 0.737311 0.378906 0.990763 0.378906 1.25495C0.378906 1.51913 0.483448 1.77259 0.669699 1.95995L4.2097 5.49995L0.669699 9.03995C0.483448 9.22731 0.378906 9.48076 0.378906 9.74495C0.378906 10.0091 0.483448 10.2626 0.669699 10.4499C0.763139 10.5426 0.873955 10.616 0.995792 10.6657C1.11763 10.7155 1.24809 10.7407 1.3797 10.7399C1.51131 10.7407 1.64177 10.7155 1.76361 10.6657C1.88544 10.616 1.99626 10.5426 2.0897 10.4499L6.3297 6.20995C6.42343 6.11699 6.49782 6.00638 6.54859 5.88453C6.59936 5.76267 6.6255 5.63196 6.6255 5.49995C6.6255 5.36794 6.59936 5.23723 6.54859 5.11537C6.49782 4.99351 6.42343 4.88291 6.3297 4.78995Z",
    fill: "#776F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.8d7293da7e3248fe431ab9716c3d5cb7.svg";
export { ForwardRef as ReactComponent };